import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useEffect, useState } from 'react';
import { ADD_ON_CARD } from '../../v2/constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { productsFromProductInventoryQuantitySelector } from '../../selectors/ProductInventorySelectors';
import { billingNameKeySelector, packagedQuantityBySkuIdSelector, productForSkuIdSelector, unitNameForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtilsLegacy';
import { ErrorBoundary } from '../../v2/components/error-boundary/ErrorBoundary';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { AddOnCardCTA } from './AddOnCardCTA';
import { AddOnCardCTAFallback, AddOnCardPricingFallback } from './AddOnCardFallbacks';
import AddOnCardLayoutUI from './AddOnCardLayoutUI';
import { AddOnCardPricing } from './AddOnCardPricing';
import { CardLayoutAlert } from './CardLayoutAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddOnCard = ({
  screen,
  skuId
}) => {
  const [ctaDebouncing, setCtaDebouncing] = useState(true);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const ownedQuantity = useAppSelector(state => productsFromProductInventoryQuantitySelector(state, {
    skuId
  }));
  const [selectedQuantity, setSelectedQuantity] = useState(0);

  // intentionally slowdown the cta button from rendering so that when searching / filtering add-ons,
  // the cta button doesn't render immediately (it's an expensive operation)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setCtaDebouncing(false);
    }, 300);
    return () => {
      clearTimeout(timeout);
    };
  });
  const unitName = useAppSelector(state => unitNameForSkuIdSelector(state, {
    skuId
  }));
  const packagedQuantities = useAppSelector(state => {
    var _packagedQuantityBySk;
    return unitName ? (_packagedQuantityBySk = packagedQuantityBySkuIdSelector(state, {
      skuId,
      unitName
    })) !== null && _packagedQuantityBySk !== void 0 ? _packagedQuantityBySk : 1 : 1;
  });
  const isAppReady = useGlobalLoading();
  const productConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity + ownedQuantity
  })];
  const productPricingConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity
  })];
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `${ADD_ON_CARD}-${product.apiName}`,
    "data-selenium-id": `${ADD_ON_CARD}-${product.apiName}`,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages-ui.productNamesV2.${billingNameKey}.title`
    }),
    pricing: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !isAppReady,
      heights: [18],
      widths: [63],
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        fallback: /*#__PURE__*/_jsx(AddOnCardPricingFallback, {}),
        children: /*#__PURE__*/_jsx(AddOnCardPricing, {
          productConfigurations: productPricingConfigurations,
          skuId: skuId,
          term: queryParamTerm
        })
      })
    }),
    cta: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: ctaDebouncing || !isAppReady,
      heights: [40],
      widths: [157],
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        fallback: /*#__PURE__*/_jsx(AddOnCardCTAFallback, {
          skuId: skuId
        }),
        children: /*#__PURE__*/_jsx(AddOnCardCTA, {
          skuId: skuId,
          packagedQuantities: packagedQuantities,
          ownedQuantity: ownedQuantity,
          screen: screen,
          term: queryParamTerm,
          selectedQuantity: selectedQuantity,
          productConfigurations: productConfigurations,
          onQuantityChange: setSelectedQuantity
        })
      })
    }),
    description: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `pricing-pages-ui.productNamesV2.${billingNameKey}.paragraph`
      })
    }),
    alert: /*#__PURE__*/_jsx(CardLayoutAlert, {
      packagedQuantities: packagedQuantities,
      ownedQuantity: ownedQuantity,
      isHubSpotCredits: false,
      includedDefaultUnits: packagedQuantities,
      titleString: I18n.text(`pricing-pages-ui.productNamesV2.${billingNameKey}.title`)
    })
  });
};
export default AddOnCard;